import React, {useContext, useState} from 'react'

import {StorageContext} from '../context'

import OverlookedSlider from './OverlookedSlider'

const Overlooked = () => {
  const storage = useContext(StorageContext);
  const [sliderData, setSliderData] = useState([]);

  const overlooked = storage.getViewed();

  const params = overlooked.reduce((params, id) => params = `${params}id[]=${id}&`, '');

  return (
    <section className="product-card__overlooked-slider">
      {overlooked.length ? <h3>Вы смотрели:</h3> : false}
      <OverlookedSlider params={params}
                        countOfViewed={5}
                        sliderData={sliderData}
                        setSliderData={setSliderData}/>
    </section>
  )
};

export default Overlooked
